<template>
  <div class="link-container">
    <div
      role="link"
      class="descriptive-link is-paddingless is-radiusless"
      @click="navigate"
    >
      <div class="icon-container">
        <slot name="icon" />
      </div>
      <div class="description-container is-padded-small has-text-centered">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    pathTo: {
      type: String,
      required: true,
    }
  },
  methods: {
    navigate () {
      this.$router.push(this.pathTo)
    }
  }
}
</script>

<style lang="scss">
@import "./src/assets/colorpallet.scss";
.icon-container {
  img {
    display: block;
    @include desktop {
      width: 271px;
      max-width: 101%;
    }

    @include mobile {
      width: 96px;
      height: 96px;
    }
  }
}
</style>

<style lang="scss" scoped>
@import "./src/assets/colorpallet.scss";

.link-container {
  cursor: pointer;
  background-color: transparent;
  @include mobile {
    background-color: $white;
  }
}

.descriptive-link {
  @include mobile {
    display: flex;
    height: 96px;
  }

  .icon-container {
    display: inline-block;

    @include mobile {
      height: 96px !important;
      width: 96px !important;
      flex-shrink: 0;
    }

    @include desktop {
      width: 272px;
      margin-bottom: -10px;
    }
  }

  .description-container {
    @include desktop {
      width: 270px;
    }
    background-color: $white;
    vertical-align: middle;
    @include mobile {
      justify-content: center;
      flex-grow: 1;
      align-self: center;
      * {
        font-size: 0.8rem !important;
      }
    }
  }
}
</style>
